<template>
  <div :class="$style.switch">
    <div
      v-for="(item, index) in views"
      :key="index"
      :class="[$style.switch_item, item.type === active ? $style.active : '']"
      class="gp_autotes_resource_switch"
      @click="$emit('onToggleSwitch', item)"
    >
      {{ item.text }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    active: {
      type: String,
      required: false,
      default: '',
    },
  },
  emits: [
    'onToggleSwitch',
  ],
  data() {
    return {
      views: [
        {
          type: 'people',
          text: __('resources_manage_layout_header_title_1'),
        },
        {
          type: 'material',
          text: __('resources_manage_layout_header_title_2'),
        },
      ],
    };
  },
};
</script>

<style module src='./switch.less' />
